import { garageApi } from "../api/endpoints"

export type TelegramInvoiceStatus = "paid" | "cancelled" | "failed" | "pending"

export interface StarsInvoice {
  payment_id: number
  invoice_url: string
  amount_stars: number
  purpose: string
}

function openInvoice(url: string): Promise<TelegramInvoiceStatus> {
  return new Promise((resolve, reject) => {
    const tg = window.Telegram?.WebApp
    if (!tg?.openInvoice) {
      reject(new Error("Telegram invoice API недоступен"))
      return
    }
    try {
      tg.openInvoice(url, (status) => resolve(status))
    } catch (error) {
      reject(error)
    }
  })
}

function sleep(ms: number) {
  return new Promise((resolve) => window.setTimeout(resolve, ms))
}

export async function completeStarsInvoice(invoice: StarsInvoice): Promise<boolean> {
  const invoiceStatus = await openInvoice(invoice.invoice_url)

  if (invoiceStatus === "cancelled" || invoiceStatus === "failed") {
    await garageApi.cancelPayment(invoice.payment_id).catch(() => undefined)
    return false
  }

  for (let attempt = 0; attempt < 30; attempt += 1) {
    const payment = await garageApi.getPaymentStatus(invoice.payment_id)
    if (payment.status === "completed") return true
    if (["cancelled", "failed", "refunded"].includes(payment.status)) return false
    await sleep(500)
  }

  throw new Error("Telegram подтвердил оплату, но активация ещё обрабатывается. Откройте Гараж через несколько секунд.")
}
